import { Controller } from '@hotwired/stimulus'

// Cesión de datos a entidades financieras colaboradoras en la página genérica de
// subida de documentación (ENH-RNK-025). Replica el comportamiento del captador
// pero SIN simulación: el modal lista TODOS los brokers con cesión vigente (no
// los recomendados). El texto legal del checkbox trae un enlace
// `<a onclick="openClientes(event)">`, así que exponemos esa función global mientras
// el controller está conectado.
//
// Los brokers se PRECARGAN al conectar, así sus checkboxes existen en el form
// desde el inicio: marcar el check general los marca todos y se envían aunque el
// usuario no abra el modal (abrirlo es solo para revisar/desmarcar).
//
// Targets:
//   - checkCesion: el checkbox `consentimiento_cesion`
//   - lista: el div donde se pintan los brokers (#datos-terceras-empresas)
// Values:
//   - url: endpoint JSON con los brokers de cesión vigente
export default class extends Controller {
  static targets = ['checkCesion', 'lista']
  static values = { url: String }

  connect () {
    window.openClientes = this.abrirModal.bind(this)
    this.cargarBrokers()
  }

  disconnect () {
    if (window.openClientes === this.abrirModal) window.openClientes = undefined
  }

  // El enlace "entidades financieras colaboradoras" vive DENTRO del <label> del
  // checkbox de cesión y no lleva href, así que al clicarlo el navegador activa
  // el label y marca el check (marcando de paso todos los brokers). Cancelamos
  // el evento para que abrir el modal no toque el estado del consentimiento.
  abrirModal (event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    const listo = this.listaPintada() ? Promise.resolve() : this.cargarBrokers()
    listo.then(() => {
      const modal = document.querySelector('#terceras-empresas')
      if (modal && modal.open) modal.open()
    })
  }

  cargarBrokers () {
    return fetch(this.urlValue, { headers: { Accept: 'application/json' } })
      .then(response => response.json())
      .then(brokers => this.pintarBrokers(brokers))
      .catch(error => console.error('Error cargando brokers de cesión:', error))
  }

  pintarBrokers (brokers) {
    if (!this.hasListaTarget) return
    const marcar = this.todosMarcados()
    const items = brokers.map(broker => this.itemHtml(broker, marcar)).join('')
    this.listaTarget.innerHTML = `<div>${items}</div>`
  }

  itemHtml (broker, marcar) {
    const checked = marcar ? 'checked' : ''
    const id = `cliente_cesion_${broker.id}`
    return `<div><small><label for='${id}'>` +
      `<input type='checkbox' name='clientes[]' id='${id}' value='[${broker.id},${broker.partner_id}]' ${checked}>` +
      `<span>${broker.html}</span></label></small></div>`
  }

  // Al marcar/desmarcar el check de cesión, marca/desmarca todos los brokers. Si
  // la precarga aún no terminó (o falló), los carga ahora — vendrán marcados
  // porque el check ya está activo.
  toggleTodos () {
    if (!this.hasListaTarget) return
    if (!this.listaPintada()) {
      this.cargarBrokers()
      return
    }
    const marcar = this.todosMarcados()
    this.brokerInputs().forEach(input => { input.checked = marcar })
  }

  listaPintada () {
    return this.hasListaTarget && this.brokerInputs().length > 0
  }

  brokerInputs () {
    return this.listaTarget.querySelectorAll('input[name="clientes[]"]')
  }

  todosMarcados () {
    return this.hasCheckCesionTarget && this.checkCesionTarget.checked
  }
}
